var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row-info" }, [
        _c("div", { staticClass: "row-info-title" }, [
          _vm._v(" 设备信息"),
          _vm.infoData.dev_status != "online"
            ? _c("span", { staticClass: "edit-icon-div" }, [
                _c("img", {
                  staticClass: "width-full",
                  attrs: {
                    src: require("../../assets/img/buttonedit.svg"),
                    alt: "",
                  },
                  on: { click: _vm.showUpdataDevModel },
                }),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "row-info-contant" },
          [
            _c("span", { staticClass: "row-info-contant-title" }, [
              _vm._v("设备名称"),
            ]),
            _c(
              "v-tooltip",
              {
                attrs: {
                  enterable: false,
                  "between-space": 0,
                  "show-only-ellipsis": "",
                  content: _vm.infoData.dev_name,
                },
              },
              [
                _c("span", { staticClass: "row-info-contant-contant" }, [
                  _vm._v(_vm._s(_vm.infoData.dev_name)),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row-info-contant" },
          [
            _c("span", { staticClass: "row-info-contant-title" }, [
              _vm._v("设备KEY"),
            ]),
            _c(
              "v-tooltip",
              {
                attrs: {
                  enterable: false,
                  "between-space": 0,
                  "show-only-ellipsis": "",
                  content: _vm.infoData.dev_key,
                },
              },
              [
                _c("span", { staticClass: "row-info-contant-contant" }, [
                  _vm._v(_vm._s(_vm.infoData.dev_key)),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row-info-contant" },
          [
            _c("span", { staticClass: "row-info-contant-title" }, [
              _vm._v("设备MAC"),
            ]),
            _c(
              "v-tooltip",
              {
                attrs: {
                  enterable: false,
                  "between-space": 0,
                  "show-only-ellipsis": "",
                  content: _vm.infoData.dev_mac,
                },
              },
              [
                _c("span", { staticClass: "row-info-contant-contant" }, [
                  _vm._v(_vm._s(_vm.infoData.dev_mac)),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row-info-contant" },
          [
            _c("span", { staticClass: "row-info-contant-title" }, [
              _vm._v("产品名称"),
            ]),
            _c(
              "v-tooltip",
              {
                attrs: {
                  enterable: false,
                  "between-space": 0,
                  "show-only-ellipsis": "",
                  content: _vm.infoData.product_name,
                },
              },
              [
                _c("span", { staticClass: "row-info-contant-contant" }, [
                  _vm._v(_vm._s(_vm.infoData.product_name)),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row-info-contant" },
          [
            _c("span", { staticClass: "row-info-contant-title" }, [
              _vm._v("产品标识"),
            ]),
            _c(
              "v-tooltip",
              {
                attrs: {
                  enterable: false,
                  "between-space": 0,
                  "show-only-ellipsis": "",
                  content: _vm.infoData.product_key,
                },
              },
              [
                _c("span", { staticClass: "row-info-contant-contant" }, [
                  _vm._v(_vm._s(_vm.infoData.product_key)),
                ]),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("设备状态"),
          ]),
          _c(
            "span",
            { staticClass: "row-info-contant-contant" },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    enterable: false,
                    "between-space": 0,
                    "show-only-ellipsis": "",
                    content:
                      _vm.infoData.dev_status == "online" ? "在线" : "离线",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      class:
                        _vm.infoData.dev_status == "online"
                          ? "online"
                          : "offline",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.infoData.dev_status == "online" ? "在线" : "离线"
                        )
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm.infoData.dev_status == "online"
          ? _c(
              "div",
              { staticClass: "row-info-contant" },
              [
                _c("span", { staticClass: "row-info-contant-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.infoData.dev_status == "online"
                        ? "上线时间"
                        : "上一次上线"
                    )
                  ),
                ]),
                _c(
                  "v-tooltip",
                  {
                    attrs: {
                      enterable: false,
                      "between-space": 0,
                      "show-only-ellipsis": "",
                      content: _vm.infoData.online_time || "未上线",
                    },
                  },
                  [
                    _c("span", { staticClass: "row-info-contant-contant" }, [
                      _vm._v(_vm._s(_vm.infoData.online_time || "未上线")),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "row-info-contant" },
              [
                _c("span", { staticClass: "row-info-contant-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.infoData.dev_status == "online"
                        ? "上一次离线"
                        : "离线时间"
                    )
                  ),
                ]),
                _c(
                  "v-tooltip",
                  {
                    attrs: {
                      enterable: false,
                      "between-space": 0,
                      "show-only-ellipsis": "",
                      content: _vm.infoData.offline_time,
                    },
                  },
                  [
                    _c("span", { staticClass: "row-info-contant-contant" }, [
                      _vm._v(_vm._s(_vm.infoData.offline_time)),
                    ]),
                  ]
                ),
              ],
              1
            ),
        _c(
          "div",
          { staticClass: "row-info-contant" },
          [
            _c("span", { staticClass: "row-info-contant-title" }, [
              _vm._v("创建时间"),
            ]),
            _c(
              "v-tooltip",
              {
                attrs: {
                  enterable: false,
                  "between-space": 0,
                  "show-only-ellipsis": "",
                  content: _vm.infoData.created_at_str,
                },
              },
              [
                _c("span", { staticClass: "row-info-contant-contant" }, [
                  _vm._v(_vm._s(_vm.infoData.created_at_str)),
                ]),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("分组名称"),
          ]),
          _vm.infoData.group_name
            ? _c("span", { staticClass: "row-info-contant-contant" }, [
                _vm._v(_vm._s(_vm.infoData.group_name)),
              ])
            : _vm._e(),
          !_vm.infoData.group_id
            ? _c(
                "span",
                { staticClass: "handle-button" },
                [
                  _c(
                    "v-button",
                    {
                      attrs: {
                        slot: "reference",
                        size: "S",
                        type: "text",
                        name: "btn2",
                      },
                      on: { click: _vm.showDevToGroupModel },
                      slot: "reference",
                    },
                    [_vm._v("添加设备到分组")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.infoData.group_id
            ? _c(
                "span",
                { staticClass: "handle-button" },
                [
                  _c(
                    "v-button",
                    {
                      attrs: {
                        slot: "reference",
                        size: "S",
                        type: "text",
                        name: "btn2",
                      },
                      on: { click: _vm.showDevToGroupModel },
                      slot: "reference",
                    },
                    [_vm._v("编辑")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("操作"),
          ]),
          _c(
            "span",
            { staticClass: "row-info-contant-contant" },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    enterable: false,
                    "between-space": 0,
                    "show-only-ellipsis": "",
                    content: _vm.infoData.dev_name,
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "handle-button" },
                    [
                      _c(
                        "v-button",
                        {
                          attrs: {
                            slot: "reference",
                            size: "S",
                            type: "text",
                            name: "btn-text1",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showUpgradeModel()
                            },
                          },
                          slot: "reference",
                        },
                        [_vm._v("固件升级")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("UpdataDevice", {
        ref: "UpdataDev",
        attrs: {
          showInputDialog: _vm.UpdataDevloading,
          infoData: _vm.infoData,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.UpdataDevloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.UpdataDevloading = $event
          },
          getData: _vm.getData,
        },
      }),
      _c("AddDevToGroup", {
        ref: "AddDevToGroup",
        attrs: {
          showInputDialog: _vm.AddDevToGrouploading,
          devId: _vm.devId,
          groupId: _vm.groupId,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.AddDevToGrouploading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.AddDevToGrouploading = $event
          },
          getData: _vm.getData,
        },
      }),
      _c("Upgrade", {
        ref: "Del",
        attrs: {
          showInputDialog: _vm.Upgradeloading,
          product_key: _vm.product_key,
          device_key: _vm.device_key,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Upgradeloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Upgradeloading = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }